import React, { useRef, useEffect, useState } from 'react'
import { makeStyles, Button } from '@material-ui/core'

const useStyles = makeStyles({
  root: {
    height: '100%',
    fontFamily: 'Montserrat',
    color: '#818284',
    letterSpacing: -0.4,
    fontSize: 32,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center'
  },
  description: props => ({
    height: '80%', 
    fontSize: props.isMobile ? 22 : 30
  }),
  button: {
    height: '20%', 
    display: 'flex', 
    justifyContent: 'center',
    alignItems: 'center'
  }
})

export default function TextSection(props){

  const classes = useStyles(props)

  const { description, scrollToUploadSection } = props

  const [overflown, setOverflown] = useState(false)

  const descRef = useRef()

  useEffect(() => {
    if(description){
      const element = descRef.current
      const hasOverflowingChildren = element.offsetHeight < element.scrollHeight ||
                                 element.offsetWidth < element.scrollWidth
      setOverflown(hasOverflowingChildren)
    }
  }, [description])


  return (
    <div className={classes.root}>
      <div 
        ref={descRef} 
        className={classes.description} 
        style={{ overflowY: overflown ? 'scroll' : 'hidden' }}>
        {description}
      </div>
      <div className={classes.button}>
        <Button
          style={{fontSize: 'large'}} 
          variant="contained" 
          color="secondary" 
          onClick={scrollToUploadSection}>Get Started</Button>
      </div>
    </div>
  )
}